// extracted by mini-css-extract-plugin
export default {"formCont":"NewTopic_formCont__10zXp","plus-icon":"NewTopic_plus-icon__5ECPH","input-container":"NewTopic_input-container__Dynng","modal":"NewTopic_modal__mXKML"};